export function mergeSubscriptionPatch(subscription, patch) {
  return {
    ...(subscription || {}),
    ...(patch || {}),
  };
}

export function getSubscriptionErrorMessage(error) {
  if (typeof error === "string" && error.trim()) return error;
  if (error?.message) return error.message;
  if (error?.userMessage) return error.userMessage;
  return "The subscription request could not be completed.";
}

export function isSubscriptionStateConflict(error) {
  return error?.code === "subscription_state_conflict";
}
